// extracted by mini-css-extract-plugin
module.exports = {"accordionItem":"styles_accordionItem__JeTcJ"};